<h6>Latest Request</h6>
<div class="form-row">
    <div class="col-md-5 mb-3">
        <label>ID</label>
        <input type="text" class="form-control" value="{{latestRequest.RequestID}}" readonly>
    </div>
    <div class="col-md-3 mb-3">
        <label>Date</label>
        <input type="text" class="form-control" value="{{latestRequest.RequestTime | string2date}}" readonly>
    </div>
    <div class="col-md-3 mb-3">
        <label>Response Status</label>
        <input type="text" class="form-control" value="{{latestRequest.ResponseStatus}}" readonly>
    </div>
    <div class="col-md-1 ml-auto">
        <div class="mb-2">&nbsp;</div>
        <button type="button" class="btn btn-light form-control" (click)="ngOnInit()">Refresh</button>
    </div>
    <!-- <form class="form-inline">
        <div class="mr-auto"></div>
        
    </form> -->
</div>

<hr/>
<h6 class="mt-4">Send customer a personal self-update</h6>
<div class="input-group">
    <div class="custom-file">
        <input type="file" class="custom-file-input" id="customFile" (change)="onFileChange($event)">
        <label class="custom-file-label" for="customFile">{{file ? file.name : 'Select file'}}</label>
    </div>
    <div class="input-group-append">
        <button class="btn btn-primary" type="button" (click)="onFileSend()">Send</button>
    </div>
</div>